// // 10:30

export const Ten = [
  [
    { id: "08", value: "23" },
    { id: "09", value: "56" },
    { id: "04", value: "34" },
    { id: "05", value: "11" },
    { id: "06", value: "69" },
    { id: "07", value: "23" },
    { id: 14, value: "23" },
  ],
  [
    { id: 10, value: "20" },
    { id: 11, value: "19" },
    { id: "01", value: "12" },
    { id: "02", value: "45" },
    { id: "03", value: "46" },
    { id: 12, value: "13" },
    { id: 13, value: "32" },
  ],
  [
    { id: 26, value: "20" },
    { id: 27, value: "03" },
    { id: 28, value: "01" },
    { id: 18, value: "17" },
    { id: 19, value: "20" },
    { id: 20, value: "06" },
    { id: 21, value: "10" },
  ],
  [
    { id: 22, value: "03" },
    { id: 23, value: "26" },
    { id: 24, value: "34" },
    { id: 25, value: "33" },
    { id: 29, value: "53" },
    { id: 30, value: "02" },
    { id: 31, value: "25" },
  ],
  [
    { id: 32, value: "97" },
    { id: 33, value: "04" },
    { id: 37, value: "46" },
    { id: 38, value: "17" },
    { id: 39, value: "30" },
    { id: 34, value: "46" },
    { id: 35, value: "94" },
  ],
  [
    { id: 36, value: "07" },

    { id: 40, value: "02" },
    { id: 15, value: "62" },
    { id: 16, value: "54" },
    { id: 17, value: "62" },
    { id: 41, value: "11" },
    { id: 42, value: "29" },
  ],
  [
    { id: 43, value: "08" },
    { id: 44, value: "56" },
    { id: 45, value: "29" },
    { id: 46, value: "53" },
    { id: 47, value: "38" },
    { id: 48, value: "17" },
    { id: 49, value: "25" },
  ],
  [
    { id: 54, value: "90" },
    { id: 55, value: "13" },
    { id: 56, value: "15" },
    { id: 64, value: "89" },
    { id: 65, value: "10" },
    { id: 66, value: "99" },
    { id: 50, value: "46" },
  ],
  [
    { id: 60, value: "25" },
    { id: 61, value: "01" },
    { id: 75, value: "93" },
    { id: 76, value: "02" },
    { id: 77, value: "75" },
    { id: 62, value: "40" },
    { id: 63, value: "13" },
  ],
  [
    { id: 67, value: "93" },
    { id: 68, value: "97" },
    { id: 57, value: "18" },
    { id: 58, value: "02" },
    { id: 59, value: "99" },
    { id: 69, value: "04" },
    { id: 70, value: "96" },
  ],
  [
    { id: 53, value: "25" },
    { id: 72, value: "02" },
    { id: 73, value: "24" },
    { id: 74, value: "03" },
    { id: 85, value: "61" },
    { id: 86, value: "25" },
    { id: 87, value: "64" },
  ],
  [
    { id: 81, value: "31" },
    { id: 82, value: "64" },
    { id: 83, value: "13" },
    { id: 84, value: "07" },
    { id: 71, value: "92" },
    { id: 51, value: "03" },
    { id: 52, value: "36" },
  ],
  [
    { id: 88, value: "86" },
    { id: 95, value: "04" },
    { id: 96, value: "46" },
    { id: 97, value: "56" },
    { id: 98, value: "42" },
    { id: 89, value: "63" },
    { id: 90, value: "93" },
  ],
  [
    { id: 78, value: "01" },
    { id: 79, value: "19" },
    { id: 80, value: "29" },
    { id: 92, value: "61" },
    { id: 93, value: "43" },
    { id: 94, value: "72" },
    { id: 91, value: "58" },
  ],
  [
    { id: 102, value: "59" },
    { id: 103, value: "98" },
    { id: 104, value: "16" },
    { id: 105, value: "19" },
    { id: 113, value: "27" },
    { id: 114, value: "09" },
    { id: 99, value: "27" },
  ],
  [
    { id: 109, value: "94" },
    { id: 110, value: "67" },
    { id: 111, value: "43" },
    { id: 112, value: "28" },
    { id: 123, value: "68" },
    { id: 124, value: "06" },
    { id: 125, value: "30" },
  ],
  [
    { id: 116, value: "76" },
    { id: 117, value: "06" },
    { id: 118, value: "17" },
    { id: 119, value: "84" },
    { id: 106, value: "92" },
    { id: 107, value: "85" },
    { id: 108, value: "06" },
  ],
  [
    { id: 115, value: "55" },
    { id: 122, value: "16" },
    { id: 126, value: "70" },
    { id: 120, value: "49" },
    { id: 121, value: "63" },
    { id: 100, value: "08" },
    { id: 101, value: "55" },
  ],
  [
    { id: 130, value: "36" },
    { id: 131, value: "71" },
    { id: 132, value: "93" },
    { id: 133, value: "49" },
    { id: 134, value: "08" },
    { id: 135, value: "58" },
    { id: 127, value: "20" },
  ],
  [
    { id: 128, value: "08" },
    { id: 129, value: "41" },
    { id: 136, value: "50" },
    { id: 141, value: "16" },
    { id: 142, value: "94" },
    { id: 137, value: "38" },
    { id: 143, value: "35" },
  ],
  [
    { id: 138, value: "29" },
    { id: 139, value: "89" },
    { id: 140, value: "02" },
    { id: 143, value: "35" },
    { id: 144, value: "71" },
    { id: 145, value: "22" },
    { id: 146, value: "96" },
  ],
  [
    { id: 148, value: "90" },
    { id: 149, value: "34" },
    { id: 150, value: "10" },
    { id: 151, value: "05" },
    { id: 152, value: "60" },
    { id: 153, value: "27" },
    { id: 154, value: "37" },
  ],
  [
    { id: 158, value: "39" },
    { id: 171, value: "15" },
    { id: 172, value: "12" },
    { id: 161, value: "08" },
    { id: 173, value: "58" },
    { id: 159, value: "09" },
    { id: 160, value: "79" },
  ],
  [
    { id: 162, value: "15" },
    { id: 163, value: "38" },
    { id: 164, value: "56" },
    { id: 165, value: "23" },
    { id: 166, value: "37" },
    { id: 167, value: "75" },
    { id: 168, value: "04" },
  ],
  [
    { id: 169, value: "84" },
    { id: 155, value: "23" },
    { id: 156, value: "26" },
    { id: 157, value: "20" },
    { id: 170, value: "12" },
    { id: 174, value: "56" },
    { id: 175, value: "23" },
  ],
  [
    { id: 180, value: "59" },
    { id: 181, value: "19" },
    { id: 183, value: "14" },

    { id: 193, value: "78" },
    { id: 194, value: "61" },
    { id: 195, value: "70" },
    { id: 196, value: "63" },
  ],
  [
    { id: 177, value: "73" },
    { id: 178, value: "68" },
    { id: 179, value: "12" },
    { id: 185, value: "23" },
    { id: 186, value: "12" },
    { id: 197, value: "56" },
    { id: 198, value: "75" },
  ],
  [
    { id: 184, value: "11" },
    { id: 176, value: "13" },
    { id: 182, value: "14" },
    { id: 189, value: "11" },
    { id: 190, value: "11" },
    { id: 191, value: "71" },
    { id: 192, value: "52" },
  ],
  [
    { id: 201, value: "45" },
    { id: 202, value: "71" },
    { id: 203, value: "23" },
    { id: 199, value: "93" },
    { id: 200, value: "68" },
    { id: 187, value: "12" },
    { id: 188, value: "11" },
  ],
];

// 11.30

export const Eleven = [
  [
    { id: "02", value: "77" },
    { id: "03", value: "55" },
    { id: "04", value: "43" },
    { id: "07", value: "85" },
    { id: 14, value: "79" },
    { id: "05", value: "14" },
    { id: "06", value: "75" },
  ],
  [
    { id: "08", value: "31" },
    { id: 12, value: "01" },

    { id: "09", value: "08" },
    { id: 10, value: "52" },
    { id: 11, value: "15" },
    { id: "01", value: "76" },
    { id: 13, value: "49" },
  ],
  [
    { id: 17, value: "42" },
    { id: 24, value: "11" },
    { id: 26, value: "07" },
    { id: 25, value: "11" },
    { id: 18, value: "27" },
    { id: 19, value: "03" },

    { id: 21, value: "29" },
  ],
  [
    { id: 22, value: "32" },
    { id: 23, value: "83" },

    { id: 15, value: "16" },
    { id: 16, value: "73" },
    { id: 27, value: "12" },
    { id: 20, value: "28" },
    { id: 28, value: "18" },
  ],
  [
    { id: 30, value: "28" },
    { id: 40, value: "98" },

    { id: 31, value: "49" },
    { id: 47, value: "15" },

    { id: 33, value: "94" },
    { id: 36, value: "72" },

    { id: 34, value: "99" },
  ],
  [
    { id: 44, value: "41" },
    { id: 35, value: "69" },
    { id: 32, value: "61" },

    { id: 37, value: "11" },
    { id: 38, value: "84" },
    { id: 39, value: "07" },
    { id: 42, value: "07" },
  ],
  [
    { id: 43, value: "99" },
    { id: 29, value: "41" },
    { id: 41, value: "11" },

    { id: 45, value: "67" },

    { id: 46, value: "74" },
    { id: 48, value: "88" },
    { id: 49, value: "40" },
  ],
  [
    { id: 61, value: "76" },
    { id: 59, value: "22" },
    { id: 60, value: "53" },
    { id: 52, value: "71" },
    { id: 53, value: "71" },
    { id: 54, value: "13" },
    { id: 62, value: "52" },
  ],
  [
    { id: 57, value: "11" },
    { id: 58, value: "11" },

    { id: 64, value: "30" },
    { id: 65, value: "68" },
    { id: 50, value: "05" },
    { id: 51, value: "62" },

    { id: 63, value: "66" },
  ],
  [
    { id: 55, value: "29" },
    { id: 66, value: "82" },
    { id: 67, value: "77" },
    { id: 68, value: "48" },
    { id: 69, value: "30" },
    { id: 70, value: "16" },
    { id: 56, value: "54" },
  ],
  [
    { id: 72, value: "66" },
    { id: 78, value: "26" },
    { id: 88, value: "37" },
    { id: 90, value: "40" },

    { id: 73, value: "11" },
    { id: 74, value: "90" },
    { id: 76, value: "78" },
  ],
  [
    { id: 79, value: "37" },
    { id: 77, value: "90" },

    { id: 80, value: "96" },
    { id: 75, value: "48" },

    { id: 91, value: "78" },

    { id: 82, value: "43" },
    { id: 84, value: "25" },
  ],
  [
    { id: 71, value: "65" },
    { id: 83, value: "89" },

    { id: 86, value: "07" },
    { id: 87, value: "29" },
    { id: 85, value: "78" },

    { id: 81, value: "31" },
    { id: 89, value: "52" },
  ],
  [
    { id: 95, value: "83" },
    { id: 96, value: "02" },
    { id: 99, value: "39" },
    { id: 100, value: "25" },
    { id: 101, value: "07" },
    { id: 97, value: "66" },
    { id: 98, value: "47" },
  ],
  [
    { id: 102, value: "89" },
    { id: 103, value: "17" },
    { id: 104, value: "97" },
    { id: 106, value: "39" },
    { id: 107, value: "25" },
    { id: 108, value: "98" },
    { id: 105, value: "15" },
  ],
  [
    { id: 92, value: "84" },
    { id: 93, value: "32" },
    { id: 94, value: "63" },
    { id: 109, value: "63" },
    { id: 110, value: "93" },
    { id: 111, value: "49" },
    { id: 112, value: "79" },
  ],
  [
    { id: 116, value: "05" },
    { id: 117, value: "17" },
    { id: 126, value: "97" },

    { id: 120, value: "18" },
    { id: 121, value: "63" },
    { id: 129, value: "21" },
    { id: 119, value: "15" },
  ],
  [
    { id: 118, value: "85" },
    { id: 127, value: "83" },
    { id: 128, value: "37" },
    { id: 122, value: "16" },
    { id: 123, value: "93" },
    { id: 124, value: "29" },
    { id: 125, value: "31" },
  ],
  [
    { id: 130, value: "04" },
    { id: 113, value: "44" },
    { id: 114, value: "69" },
    { id: 115, value: "98" },
    { id: 131, value: "89" },
    { id: 132, value: "66" },
    { id: 133, value: "84" },
  ],
  [
    { id: 148, value: "91" },
    { id: 141, value: "68" },
    { id: 142, value: "45" },
    { id: 143, value: "19" },
    { id: 137, value: "18" },
    { id: 138, value: "64" },
    { id: 140, value: "35" },
  ],
  [
    { id: 134, value: "37" },
    { id: 136, value: "42" },
    { id: 144, value: "34" },
    { id: 139, value: "27" },
    { id: 145, value: "63" },
    { id: 152, value: "95" },
    { id: 153, value: "56" },
  ],
  [
    { id: 135, value: "12" },
    { id: 149, value: "49" },
    { id: 150, value: "53" },
    { id: 151, value: "13" },
    { id: 146, value: "64" },
    { id: 147, value: "20" },
    { id: 154, value: "89" },
  ],
  [
    { id: 157, value: "83" },
    { id: 164, value: "67" },
    { id: 165, value: "92" },
    { id: 158, value: "51" },
    { id: 159, value: "65" },
    { id: 160, value: "51" },
    { id: 161, value: "62" },
  ],
  [
    { id: 162, value: "94" },
    { id: 163, value: "04" },
    { id: 155, value: "85" },
    { id: 156, value: "98" },

    { id: 166, value: "61" },
    { id: 167, value: "59" },
    { id: 168, value: "53" },
  ],
  [
    { id: 169, value: "72" },
    { id: 170, value: "15" },
    { id: 171, value: "64" },
    { id: 172, value: "66" },
    { id: 173, value: "94" },
    { id: 174, value: "87" },
    { id: 175, value: "67" },
  ],
  [
    { id: 179, value: "68" },
    { id: 180, value: "49" },
    { id: 191, value: "42" },
    { id: 192, value: "81" },
    { id: 178, value: "34" },
    { id: 181, value: "88" },
    { id: 182, value: "18" },
  ],
  [
    { id: 186, value: "19" },
    { id: 187, value: "13" },
    { id: 176, value: "15" },
    { id: 177, value: "87" },
    { id: 190, value: "12" },
    { id: 188, value: "12" },
    { id: 189, value: "45" },
  ],
  [
    { id: 193, value: "39" },
    { id: 183, value: "18" },
    { id: 184, value: "16" },
    { id: 185, value: "12" },
    { id: 194, value: "36" },
    { id: 195, value: "35" },
    { id: 196, value: "36" },
  ],
  [
    { id: "02", value: "79" },
    { id: "03", value: "20" },
    { id: "07", value: "81" },

    { id: 199, value: "46" },
    { id: 200, value: "32" },
    { id: 201, value: "21" },
    { id: 203, value: "29" },
  ],
];

// 12.30

export const Twelve = [
  [
    { id: "02", value: "79" },

    { id: 15, value: "65" },
    { id: "01", value: "77" },
    { id: "06", value: "12" },
    { id: "08", value: "54" },
    { id: "04", value: "63" },
    { id: "07", value: "81" },
  ],
  [
    { id: 19, value: "33" },
    { id: 16, value: "80" },
    { id: "03", value: "20" },
    { id: "05", value: "93" },
    { id: "09", value: "36" },
    { id: 10, value: "11" },
    { id: 11, value: "13" },
  ],
  [
    { id: 13, value: "30" },
    { id: 12, value: "17" },
    { id: 14, value: "69" },
    { id: 17, value: "04" },
    { id: 18, value: "35" },
    { id: 20, value: "25" },
    { id: 21, value: "83" },
  ],
  [
    { id: 24, value: "46" },
    { id: 37, value: "60" },
    { id: 26, value: "56" },
    { id: 33, value: "10" },
    { id: 30, value: "59" },
    { id: 28, value: "25" },
    { id: 27, value: "30" },
  ],
  [
    { id: 29, value: "45" },
    { id: 42, value: "50" },
    { id: 31, value: "19" },
    { id: 32, value: "16" },
    { id: 25, value: "99" },

    { id: 34, value: "18" },
    { id: 35, value: "20" },
  ],
  [
    { id: 36, value: "96" },
    { id: 22, value: "99" },
    { id: 23, value: "25" },

    { id: 38, value: "32" },
    { id: 39, value: "72" },
    { id: 40, value: "17" },
    { id: 41, value: "61" },
  ],
  [
    { id: 51, value: "60" },
    { id: 52, value: "99" },
    { id: 45, value: "73" },
    { id: 65, value: "70" },
    { id: 66, value: "72" },
    { id: 48, value: "28" },
    { id: 49, value: "62" },
  ],
  [
    { id: 64, value: "68" },
    { id: 43, value: "01" },
    { id: 50, value: "57" },

    { id: 53, value: "49" },
    { id: 54, value: "20" },

    { id: 47, value: "73" },
    { id: 56, value: "58" },
  ],
  [
    { id: 57, value: "58" },
    { id: 58, value: "32" },
    { id: 59, value: "33" },
    { id: 69, value: "11" },

    { id: 61, value: "71" },
    { id: 62, value: "86" },
    { id: 63, value: "63" },
  ],
  [
    { id: 55, value: "72" },
    { id: 46, value: "01" },
    { id: 44, value: "43" },
    { id: 70, value: "99" },
    { id: 60, value: "68" },
    { id: 67, value: "43" },
    { id: 68, value: "41" },
  ],
  [
    { id: 88, value: "33" },
    { id: 76, value: "11" },
    { id: 83, value: "51" },
    { id: 72, value: "33" },
    { id: 74, value: "31" },
    { id: 75, value: "21" },
    { id: 77, value: "81" },
  ],
  [
    { id: 78, value: "27" },
    { id: 79, value: "36" },
    { id: 80, value: "31" },
    { id: 71, value: "33" },
    { id: 81, value: "88" },
    { id: 82, value: "31" },
    { id: 73, value: "21" },
  ],
  [
    { id: 84, value: "16" },
    { id: 85, value: "84" },
    { id: 86, value: "55" },
    { id: 87, value: "66" },
    { id: 95, value: "61" },
    { id: 89, value: "94" },
    { id: 96, value: "88" },
  ],
  [
    { id: 92, value: "41" },
    { id: 93, value: "88" },
    { id: 94, value: "97" },
    { id: 95, value: "61" },
    { id: 96, value: "88" },
    { id: 97, value: "90" },
    { id: 98, value: "67" },
  ],
  [
    { id: 108, value: "69" },
    { id: 105, value: "18" },
    { id: 111, value: "16" },
    { id: 102, value: "27" },
    { id: 103, value: "80" },
    { id: 104, value: "27" },
    { id: 106, value: "11" },
  ],
  [
    { id: 109, value: "10" },
    { id: 101, value: "77" },
    { id: 116, value: "26" },
    { id: 117, value: "52" },
    { id: 110, value: "20" },
    { id: 107, value: "81" },
    { id: 112, value: "05" },
  ],
  [
    { id: 113, value: "55" },
    { id: 114, value: "79" },
    { id: 115, value: "42" },
    { id: 99, value: "54" },
    { id: 100, value: "42" },
    { id: 118, value: "69" },
    { id: 119, value: "90" },
  ],
  [
    { id: 129, value: "84" },
    { id: 134, value: "87" },
    { id: 124, value: "31" },
    { id: 127, value: "70" },
    { id: 128, value: "74" },
    { id: 125, value: "18" },
    { id: 126, value: "72" },
  ],
  [
    { id: 122, value: "83" },
    { id: 135, value: "37" },
    { id: 123, value: "75" },
    { id: 120, value: "77" },
    { id: 130, value: "81" },
    { id: 131, value: "86" },
    { id: 132, value: "12" },
  ],
  [
    { id: 126, value: "72" },

    { id: 121, value: "38" },
    { id: 136, value: "19" },
    { id: 137, value: "40" },
    { id: 138, value: "67" },
    { id: 139, value: "13" },
    { id: 140, value: "59" },
  ],
  [
    { id: 145, value: "35" },
    { id: 148, value: "86" },
    { id: 159, value: "52" },
    { id: 161, value: "88" },
    { id: 149, value: "95" },
    { id: 146, value: "56" },
    { id: 147, value: "31" },
  ],
  [
    { id: 161, value: "88" },
    { id: 151, value: "45" },
    { id: 152, value: "03" },
    { id: 141, value: "41" },
    { id: 142, value: "33" },
    { id: 153, value: "48" },
    { id: 154, value: "26" },
  ],
  [
    { id: 142, value: "33" },
    { id: 150, value: "18" },
    { id: 155, value: "67" },
    { id: 156, value: "31" },

    { id: 143, value: "70" },
    { id: 144, value: "55" },
    { id: 158, value: "51" },
  ],
  [
    { id: 177, value: "94" },
    { id: 174, value: "45" },
    { id: 175, value: "19" },
    { id: 172, value: "45" },
    { id: 162, value: "91" },
    { id: 167, value: "02" },
    { id: 168, value: "80" },
  ],
  [
    { id: 169, value: "58" },
    { id: 170, value: "16" },
    { id: 171, value: "68" },
    { id: 164, value: "30" },
    { id: 173, value: "78" },
    { id: 176, value: "10" },
    { id: 180, value: "30" },
  ],
  [
    { id: 197, value: "14" },
    { id: 183, value: "10" },
    { id: 178, value: "48" },
    { id: 163, value: "75" },

    { id: 179, value: "23" },
    { id: 182, value: "38" },
    { id: 189, value: "58" },
  ],
  [
    { id: 191, value: "84" },
    { id: 165, value: "31" },
    { id: 166, value: "05" },
    { id: 190, value: "13" },

    { id: 186, value: "14" },
    { id: 187, value: "14" },
    { id: 188, value: "13" },
  ],
  [
    { id: 184, value: "32" },
    { id: 185, value: "17" },
    { id: 181, value: "66" },
    { id: 194, value: "12" },
    { id: 195, value: "17" },
    { id: 196, value: "18" },
    { id: 193, value: "93" },
  ],
  [
    { id: 198, value: "63" },
    { id: 199, value: "23" },
    { id: 192, value: "73" },
    { id: 200, value: "16" },
    { id: 201, value: "57" },
    { id: 202, value: "38" },
    { id: 203, value: "13" },
  ],
];

// '01'.30

export const One = [
  [
    { id: 10, value: "15" },
    { id: 11, value: "63" },
    { id: "01", value: "40" },
    { id: "05", value: "83" },
    { id: 16, value: "16" },
    { id: 21, value: "02" },
    { id: 17, value: "34" },
  ],
  [
    { id: "08", value: "21" },
    { id: "09", value: "93" },
    { id: 20, value: "87" },

    { id: "02", value: "31" },
    { id: "03", value: "41" },
    { id: "04", value: "19" },
    { id: 12, value: "09" },
  ],
  [
    { id: 15, value: "08" },
    { id: "06", value: "51" },
    { id: "07", value: "45" },
    { id: 18, value: "55" },
    { id: 19, value: "06" },
    { id: 13, value: "16" },
    { id: 14, value: "49" },
  ],
  [
    { id: 25, value: "10" },
    { id: 26, value: "22" },
    { id: 36, value: "81" },
    { id: 39, value: "93" },
    { id: 28, value: "38" },
    { id: 34, value: "87" },
    { id: 35, value: "66" },
  ],
  [
    { id: 24, value: "21" },
    { id: 30, value: "18" },
    { id: 31, value: "82" },
    { id: 27, value: "31" },

    { id: 40, value: "44" },
    { id: 32, value: "14" },
    { id: 33, value: "67" },
  ],
  [
    { id: 29, value: "90" },
    { id: 47, value: "84" },
    { id: 37, value: "99" },
    { id: 38, value: "01" },
    { id: 43, value: "37" },

    { id: 41, value: "64" },
    { id: 42, value: "20" },
  ],
  [
    { id: 22, value: "87" },
    { id: 23, value: "79" },
    { id: 53, value: "80" },

    { id: 44, value: "37" },
    { id: 46, value: "36" },
    { id: 48, value: "04" },
    { id: 49, value: "75" },
  ],
  [
    { id: 59, value: "50" },
    { id: 52, value: "62" },
    { id: 45, value: "16" },
    { id: 51, value: "81" },
    { id: 66, value: "72" },

    { id: 54, value: "27" },
    { id: 56, value: "78" },
  ],
  [
    { id: 61, value: "09" },
    { id: 50, value: "75" },
    { id: 65, value: "02" },
    { id: 74, value: "53" },
    { id: 78, value: "64" },
    { id: 62, value: "03" },
    { id: 63, value: "33" },
  ],
  [
    { id: 64, value: "13" },
    { id: 67, value: "70" },
    { id: 57, value: "82" },
    { id: 58, value: "06" },
    { id: 60, value: "13" },
    { id: 68, value: "59" },
    { id: 74, value: "53" },
  ],
  [
    { id: 81, value: "96" },
    { id: 72, value: "39" },
    { id: 75, value: "17" },
    { id: 69, value: "47" },
    { id: 77, value: "05" },
    { id: 70, value: "74" },
    { id: 76, value: "91" },
  ],
  [
    { id: 96, value: "70" },
    { id: 89, value: "69" },
    { id: 86, value: "49" },
    { id: 78, value: "64" },
    { id: 82, value: "10" },
    { id: 83, value: "81" },
    { id: 84, value: "54" },
  ],
  [
    { id: 85, value: "38" },
    { id: 79, value: "96" },
    { id: 80, value: "78" },
    { id: 87, value: "89" },
    { id: 90, value: "31" },
    { id: 91, value: "94" },
    { id: 88, value: "80" },
  ],
  [
    { id: 92, value: "19" },
    { id: 95, value: "36" },
    { id: 101, value: "98" },
    { id: 102, value: "20" },
    { id: 96, value: "70" },
    { id: 112, value: "71" },

    { id: 98, value: "30" },
  ],
  [
    { id: 108, value: "35" },
    { id: 99, value: "89" },
    { id: 100, value: "54" },
    { id: 94, value: "75" },
    { id: 103, value: "50" },
    { id: 104, value: "76" },
    { id: 105, value: "37" },
  ],
  [
    { id: 106, value: "68" },
    { id: 107, value: "14" },
    { id: 93, value: "45" },
    { id: 109, value: "26" },
    { id: 110, value: "16" },
    { id: 97, value: "01" },

    { id: 111, value: "07" },
  ],
  [
    { id: 117, value: "14" },
    { id: 121, value: "03" },
    { id: 122, value: "53" },
    { id: 113, value: "15" },
    { id: 116, value: "67" },
    { id: 118, value: "30" },
    { id: 119, value: "43" },
  ],
  [
    { id: 120, value: "23" },
    { id: 114, value: "16" },
    { id: 115, value: "47" },
    { id: 131, value: "74" },
    { id: 123, value: "36" },
    { id: 124, value: "51" },
    { id: 126, value: "19" },
  ],
  [
    { id: 130, value: "12" },
    { id: 125, value: "74" },
    { id: 134, value: "34" },
    { id: 135, value: "30" },
    { id: 127, value: "38" },
    { id: 137, value: "15" },
    { id: 132, value: "01" },
  ],
  [
    { id: 143, value: "43" },
    { id: 129, value: "30" },
    { id: 136, value: "01" },
    { id: 138, value: "08" },
    { id: 133, value: "41" },
    { id: 139, value: "78" },
    { id: 145, value: "90" },
  ],
  [
    { id: 141, value: "70" },
    { id: 142, value: "93" },
    { id: 128, value: "23" },

    { id: 144, value: "21" },
    { id: 146, value: "66" },
    { id: 140, value: "65" },
    { id: 147, value: "63" },
  ],
  [
    { id: 148, value: "24" },
    { id: 149, value: "68" },
    { id: 150, value: "23" },
    { id: 151, value: "58" },
    { id: 152, value: "83" },
    { id: 153, value: "59" },
    { id: 154, value: "50" },
  ],
  [
    { id: 155, value: "33" },
    { id: 156, value: "58" },
    { id: 157, value: "03" },
    { id: 158, value: "46" },
    { id: 159, value: "61" },
    { id: 160, value: "72" },
    { id: 161, value: "74" },
  ],
  [
    { id: 162, value: "26" },
    { id: 163, value: "92" },
    { id: 164, value: "71" },
    { id: 165, value: "93" },
    { id: 166, value: "15" },
    { id: 167, value: "03" },
    { id: 168, value: "29" },
  ],
  [
    { id: 169, value: "47" },
    { id: 170, value: "58" },
    { id: 171, value: "95" },
    { id: 172, value: "88" },
    { id: 173, value: "48" },
    { id: 174, value: "78" },
    { id: 175, value: "11" },
  ],
  [
    { id: 176, value: "20" },
    { id: 177, value: "53" },
    { id: 178, value: "90" },
    { id: 179, value: "26" },
    { id: 180, value: "83" },
    { id: 181, value: "87" },
    { id: 182, value: "39" },
  ],
  [
    { id: 183, value: "12" },
    { id: 184, value: "54" },
    { id: 185, value: "88" },
    { id: 186, value: "18" },
    { id: 187, value: "16" },
    { id: 188, value: "43" },
    { id: 189, value: "69" },
  ],
  [
    { id: 190, value: "15" },
    { id: 191, value: "68" },
    { id: 192, value: "90" },
    { id: 193, value: "62" },
    { id: 194, value: "24" },
    { id: 195, value: "29" },
    { id: 196, value: "56" },
  ],
  [
    { id: 197, value: "85" },
    { id: 198, value: "44" },
    { id: 199, value: "78" },
    { id: 200, value: "47" },
    { id: 201, value: "69" },
    { id: 202, value: "27" },
    { id: 203, value: "56" },
  ],
];

// '02'.30
export const Two = [
  [
    { id: "05", value: "80" },
    { id: 11, value: "45" },
    { id: "01", value: "49" },
    { id: "04", value: "41" },
    { id: 13, value: "48" },
    { id: 16, value: "48" },
    { id: "06", value: "54" },
  ],
  [
    { id: 19, value: "38" },
    { id: "09", value: "33" },
    { id: 10, value: "22" },
    { id: 12, value: "19" },
    { id: 17, value: "21" },
    { id: 14, value: "89" },
    { id: "07", value: "56" },
  ],
  [
    { id: 15, value: "54" },
    { id: "02", value: "42" },
    { id: "03", value: "09" },
    { id: 18, value: "30" },
    { id: "08", value: "96" },
    { id: 21, value: "12" },
    { id: 23, value: "51" },
  ],
  [
    { id: 30, value: "65" },
    { id: 22, value: "76" },
    { id: 24, value: "69" },
    { id: 20, value: "42" },
    { id: 33, value: "60" },
    { id: 46, value: "21" },
    { id: 34, value: "85" },
  ],
  [
    { id: 44, value: "62" },
    { id: 51, value: "36" },
    { id: 27, value: "10" },
    { id: 25, value: "15" },
    { id: 32, value: "39" },
    { id: 40, value: "55" },
    { id: 35, value: "11" },
  ],
  [
    { id: 36, value: "19" },
    { id: 41, value: "98" },
    { id: 37, value: "28" },
    { id: 26, value: "19" },
    { id: 46, value: "21" },

    { id: 39, value: "52" },
    { id: 47, value: "99" },
  ],
  [
    { id: 43, value: "86" },
    { id: 29, value: "07" },
    { id: 31, value: "08" },
    { id: 45, value: "51" },
    { id: 38, value: "75" },
    { id: 48, value: "24" },
    { id: 28, value: "82" },
  ],
  [
    { id: 66, value: "51" },
    { id: 67, value: "89" },
    { id: 50, value: "91" },
    { id: 59, value: "88" },
    { id: 49, value: "62" },
    { id: 55, value: "30" },
    { id: 56, value: "62" },
  ],
  [
    { id: 69, value: "62" },
    { id: 58, value: "22" },
    { id: 60, value: "60" },
    { id: 61, value: "63" },
    { id: 62, value: "77" },
    { id: 77, value: "13" },
    { id: 63, value: "01" },
  ],
  [
    { id: 64, value: "48" },
    { id: 73, value: "50" },
    { id: 74, value: "27" },
    { id: 65, value: "61" },
    { id: 76, value: "36" },
    { id: 52, value: "35" },
    { id: 68, value: "51" },
  ],
  [
    { id: 83, value: "61" },
    { id: 72, value: "78" },
    { id: 57, value: "98" },
    { id: 75, value: "39" },
    { id: 70, value: "50" },
    { id: 78, value: "82" },
    { id: 79, value: "74" },
  ],
  [
    { id: 80, value: "68" },
    { id: 53, value: "54" },
    { id: 54, value: "30" },
    { id: 81, value: "24" },
    { id: 82, value: "03" },
    { id: 71, value: "83" },

    { id: 84, value: "56" },
  ],
  [
    { id: 93, value: "96" },
    { id: 101, value: "93" },
    { id: 102, value: "34" },
    { id: 94, value: "14" },
    { id: 87, value: "58" },
    { id: 90, value: "94" },
    { id: 91, value: "29" },
  ],
  [
    { id: 92, value: "14" },
    { id: 98, value: "24" },
    { id: 95, value: "48" },
    { id: 85, value: "49" },
    { id: 96, value: "95" },
    { id: 97, value: "13" },
    { id: 86, value: "97" },
  ],
  [
    { id: 99, value: "13" },
    { id: 100, value: "61" },
    { id: 88, value: "45" },
    { id: 109, value: "11" },
    { id: 89, value: "99" },
    { id: 103, value: "40" },
    { id: 110, value: "97" },
  ],
  [
    { id: 108, value: "41" },
    { id: 115, value: "37" },
    { id: 124, value: "91" },
    { id: 116, value: "59" },
    { id: 118, value: "69" },
    { id: 129, value: "52" },
    { id: 112, value: "33" },
  ],
  [
    { id: 113, value: "56" },
    { id: 114, value: "20" },
    { id: 117, value: "69" },
    { id: 106, value: "96" },
    { id: 107, value: "02" },
    { id: 111, value: "15" },
    { id: 119, value: "78" },
  ],
  [
    { id: 122, value: "28" },
    { id: 123, value: "29" },
    { id: 104, value: "51" },
    { id: 105, value: "61" },
    { id: 130, value: "94" },
    { id: 131, value: "05" },
    { id: 126, value: "59" },
  ],
  [
    { id: 197, value: "63" },
    { id: 198, value: "26" },
    { id: 199, value: "27" },
    { id: 200, value: "25" },
    { id: 201, value: "94" },
    { id: 202, value: "64" },
    { id: 203, value: "64" },
  ],
  [
    { id: 134, value: "74" },
    { id: 135, value: "04" },
    { id: 136, value: "43" },
    { id: 127, value: "39" },
    { id: 137, value: "79" },
    { id: 138, value: "82" },
    { id: 140, value: "21" },
  ],
  [
    { id: 146, value: "55" },
    { id: 161, value: "29" },
    { id: 144, value: "28" },
    { id: 154, value: "61" },
    { id: 159, value: "83" },
    { id: 160, value: "02" },
    { id: 147, value: "11" },
  ],
  [
    { id: 139, value: "09" },
    { id: 128, value: "92" },
    { id: 125, value: "07" },
    { id: 145, value: "50" },
    { id: 120, value: "80" },
    { id: 121, value: "50" },
    { id: 133, value: "54" },
  ],
  [
    { id: 151, value: "61" },
    { id: 141, value: "51" },
    { id: 149, value: "28" },
    { id: 132, value: "07" },
    { id: 142, value: "32" },
    { id: 152, value: "72" },
    { id: 153, value: "91" },
  ],
  [
    { id: 156, value: "63" },
    { id: 157, value: "88" },
    { id: 169, value: "38" },
    { id: 143, value: "76" },
    { id: 158, value: "41" },
    { id: 148, value: "59" },
    { id: 150, value: "76" },
  ],
  [
    { id: 162, value: "78" },
    { id: 163, value: "60" },
    { id: 173, value: "73" },
    { id: 165, value: "26" },
    { id: 166, value: "20" },
    { id: 167, value: "49" },
    { id: 168, value: "89" },
  ],
  [
    { id: 170, value: "50" },
    { id: 164, value: "21" },
    { id: 171, value: "62" },
    { id: 155, value: "76" },
    { id: 172, value: "95" },
    { id: 174, value: "47" },
    { id: 175, value: "33" },
  ],
  [
    { id: 176, value: "30" },
    { id: 180, value: "72" },
    { id: 178, value: "78" },
    { id: 179, value: "66" },
    { id: 177, value: "85" },
    { id: 181, value: "93" },
    { id: 182, value: "89" },
  ],
  [
    { id: 189, value: "46" },
    { id: 184, value: "32" },
    { id: 187, value: "25" },
    { id: 185, value: "19" },
    { id: 186, value: "53" },
    { id: 183, value: "15" },
    { id: 188, value: "21" },
  ],
  [
    { id: 22, value: "48" },
    { id: 23, value: "32" },
    { id: 24, value: "28" },
    { id: 25, value: "38" },
    { id: 26, value: "79" },
    { id: 27, value: "99" },
    { id: 28, value: "89" },
  ],
  [],
];

// '03'.30
export const Three = [
  [
    { id: 12, value: "54" },
    { id: "01", value: "11" },
    { id: "02", value: "20" },
    { id: "05", value: "20" },

    { id: 15, value: "20" },
    { id: 16, value: "49" },
    { id: "04", value: "39" },
  ],
  [
    { id: "08", value: "83" },
    { id: "09", value: "34" },
    { id: 10, value: "79" },
    { id: 11, value: "03" },
    { id: "03", value: "77" },
    { id: 13, value: "53" },
    { id: 20, value: "12" },
  ],
  [
    { id: "05", value: "20" },
    { id: 18, value: "81" },
    { id: 19, value: "52" },
    { id: "07", value: "25" },
    { id: 14, value: "20" },
    { id: 17, value: "17" },
    { id: 21, value: "99" },
  ],

  [
    { id: 33, value: "79" },
    { id: 39, value: "98" },
    { id: 46, value: "11" },
    { id: 47, value: "30" },
    { id: 34, value: "58" },
    { id: 31, value: "30" },
    { id: 35, value: "92" },
  ],
  [
    { id: 36, value: "37" },
    { id: 37, value: "91" },
    { id: 38, value: "13" },
    { id: 29, value: "62" },
    { id: 30, value: "92" },
    { id: 41, value: "06" },
    { id: 42, value: "52" },
  ],

  [
    { id: 56, value: "99" },
    { id: 60, value: "91" },
    { id: 51, value: "08" },
    { id: 53, value: "95" },
    { id: 55, value: "50" },
    { id: 66, value: "57" },
    { id: 50, value: "66" },
  ],
  [
    { id: 57, value: "69" },
    { id: 58, value: "99" },
    { id: 54, value: "79" },
    { id: 59, value: "02" },
    { id: 62, value: "22" },
    { id: 44, value: "50" },
    { id: 63, value: "48" },
  ],
  [
    { id: 69, value: "81" },
    { id: 65, value: "19" },
    { id: 45, value: "28" },
    { id: 32, value: "55" },
    { id: "06", value: "68" },
    { id: 52, value: "55" },
    { id: 32, value: "55" },
  ],
  [
    { id: 64, value: "61" },
    { id: 48, value: "35" },
    { id: 67, value: "01" },
    { id: 61, value: "91" },
    { id: 68, value: "73" },
    { id: 43, value: "74" },
    { id: 70, value: "65" },
  ],
  [
    { id: 83, value: "53" },
    { id: 72, value: "99" },
    { id: 86, value: "22" },
    { id: 74, value: "38" },
    { id: 90, value: "84" },
    { id: 77, value: "79" },
    { id: 81, value: "42" },
  ],
  [
    { id: 93, value: "18" },
    { id: 76, value: "42" },
    { id: 80, value: "45" },
    { id: 75, value: "62" },
    { id: 82, value: "64" },
    { id: 73, value: "54" },
    { id: 84, value: "94" },
  ],
  [
    { id: 85, value: "40" },
    { id: 71, value: "98" },
    { id: 87, value: "70" },
    { id: 78, value: "35" },
    { id: 88, value: "27" },
    { id: 89, value: "50" },
    { id: 91, value: "19" },
  ],
  [
    { id: 79, value: "28" },
    { id: 105, value: "08" },
    { id: 92, value: "08" },
    { id: 102, value: "83" },
    { id: 97, value: "47" },
    { id: 108, value: "09" },
    { id: 98, value: "69" },
  ],
  [
    { id: 113, value: "08" },
    { id: 99, value: "96" },
    { id: 101, value: "49" },
    { id: 94, value: "69" },
    { id: 103, value: "48" },
    { id: 112, value: "36" },
    { id: 95, value: "62" },
  ],
  [
    { id: 117, value: "70" },
    { id: 110, value: "01" },
    { id: 100, value: "57" },
    { id: 119, value: "73" },
    { id: 96, value: "89" },
    { id: 107, value: "78" },
    { id: 111, value: "94" },
  ],
  [
    { id: 120, value: "34" },
    { id: 115, value: "36" },
    { id: 104, value: "47" },
    { id: 106, value: "82" },
    { id: 118, value: "57" },
    { id: 126, value: "22" },
    { id: 109, value: "42" },
  ],
  [
    { id: 135, value: "65" },
    { id: 129, value: "76" },
    { id: 122, value: "37" },
    { id: 138, value: "58" },
    { id: 124, value: "24" },
    { id: 116, value: "04" },
    { id: 114, value: "81" },
  ],
  [
    { id: 139, value: "39" },
    { id: 131, value: "27" },
    { id: 123, value: "62" },
    { id: 130, value: "64" },
    { id: 128, value: "99" },
    { id: 125, value: "75" },
    { id: 127, value: "11" },
  ],
  [
    { id: 134, value: "04" },
    { id: 121, value: "42" },
    { id: 136, value: "76" },
    { id: 132, value: "25" },
    { id: 137, value: "23" },
    { id: 133, value: "65" },
    { id: 140, value: "69" },
  ],
  [
    { id: 160, value: "37" },
    { id: 146, value: "52" },
    { id: 143, value: "01" },
    { id: 145, value: "06" },
    { id: 151, value: "94" },
    { id: 153, value: "67" },
    { id: 147, value: "57" },
  ],
  [
    { id: 159, value: "57" },
    { id: 141, value: "36" },
    { id: 144, value: "84" },
    { id: 150, value: "79" },
    { id: 152, value: "38" },
    { id: 148, value: "26" },
    { id: 154, value: "13" },
  ],
  [
    { id: 167, value: "28" },
    { id: 142, value: "24" },
    { id: 157, value: "42" },
    { id: 172, value: "14" },
    { id: 158, value: "27" },
    { id: 149, value: "40" },
    { id: 155, value: "21" },
  ],
  [
    { id: 156, value: "39" },
    { id: 174, value: "44" },
    { id: 165, value: "64" },
    { id: 185, value: "42" },
    { id: 163, value: "61" },
    { id: 166, value: "91" },
    { id: 168, value: "57" },
  ],
  [
    { id: 186, value: "32" },
    { id: 170, value: "75" },
    { id: 182, value: "91" },
    { id: 175, value: "44" },
    { id: 161, value: "32" },
    { id: 176, value: "50" },
    { id: 171, value: "83" },
  ],
  [
    { id: 177, value: "16" },
    { id: 178, value: "53" },
    { id: 179, value: "19" },
    { id: 180, value: "37" },
    { id: 162, value: "87" },
    { id: 181, value: "79" },
    { id: 173, value: "32" },
  ],
  [
    { id: 183, value: "19" },
    { id: 164, value: "30" },
    { id: 169, value: "46" },
    { id: 184, value: "12" },
    { id: 194, value: "92" },
    { id: 188, value: "16" },
    { id: 199, value: "37" },
  ],
  [
    { id: 203, value: "16" },
    { id: 189, value: "79" },
    { id: 192, value: "38" },
    { id: 201, value: "82" },
    { id: 193, value: "17" },
    { id: 195, value: "96" },
    { id: 200, value: "54" },
  ],
  [
    { id: "05", value: "33" },
    { id: 198, value: "14" },
    { id: 187, value: "43" },
    { id: 190, value: "79" },
    { id: 196, value: "42" },
    { id: 191, value: "53" },
    { id: 202, value: "56" },
  ],
];

// '04'.30
export const Four = [
  [
    { id: 18, value: "03" },
    { id: 11, value: "27" },
    { id: 197, value: "99" },
    { id: "04", value: "55" },
    { id: "02", value: "78" },
    { id: "06", value: "16" },
    { id: 13, value: "98" },
  ],
  [
    { id: 20, value: "91" },
    { id: "08", value: "12" },
    { id: 10, value: "44" },
    { id: 12, value: "15" },
    { id: "03", value: "51" },
    { id: 14, value: "30" },
    { id: "07", value: "63" },
  ],
  [
    { id: 25, value: "27" },
    { id: 16, value: "63" },
    { id: 17, value: "37" },
    { id: "01", value: "45" },
    { id: 19, value: "76" },
    { id: "09", value: "28" },
    { id: 21, value: "37" },
  ],
  [
    { id: 40, value: "24" },
    { id: 33, value: "10" },
    { id: 23, value: "49" },
    { id: 15, value: "46" },
    { id: 26, value: "30" },
    { id: 38, value: "40" },
    { id: 28, value: "03" },
  ],
  [
    { id: 41, value: "22" },
    { id: 29, value: "94" },
    { id: 31, value: "41" },
    { id: 22, value: "10" },
    { id: 46, value: "92" },
    { id: 34, value: "08" },
    { id: 35, value: "48" },
  ],
  [
    { id: 36, value: "49" },
    { id: 42, value: "96" },
    { id: 27, value: "32" },
    { id: 39, value: "86" },
    { id: 24, value: "12" },
    { id: 30, value: "54" },
    { id: 37, value: "19" },
  ],
  [
    { id: 61, value: "12" },
    { id: 48, value: "01" },
    { id: 43, value: "59" },
    { id: 45, value: "94" },
    { id: 32, value: "05" },
    { id: 47, value: "07" },
    { id: 56, value: "21" },
  ],
  [
    { id: 65, value: "21" },
    { id: 49, value: "71" },
    { id: 62, value: "80" },
    { id: 53, value: "92" },
    { id: 50, value: "02" },
    { id: 52, value: "83" },
    { id: 55, value: "87" },
  ],
  [
    { id: 69, value: "50" },
    { id: 54, value: "01" },
    { id: 59, value: "08" },
    { id: 60, value: "40" },
    { id: 44, value: "32" },
    { id: 58, value: "54" },
    { id: 63, value: "06" },
  ],
  [
    { id: 51, value: "76" },
    { id: 66, value: "33" },
    { id: 67, value: "59" },
    { id: 76, value: "28" },
    { id: 57, value: "02" },
    { id: 64, value: "02" },
    { id: 75, value: "51" },
  ],
  [
    { id: 83, value: "72" },
    { id: 72, value: "80" },
    { id: 86, value: "73" },
    { id: 81, value: "91" },
    { id: 74, value: "35" },
    { id: 70, value: "99" },
    { id: 77, value: "18" },
  ],
  [
    { id: 78, value: "47" },
    { id: 79, value: "52" },
    { id: 80, value: "70" },
    { id: 85, value: "53" },
    { id: 82, value: "15" },
    { id: 68, value: "01" },
    { id: 84, value: "36" },
  ],
  [
    { id: 73, value: "40" },
    { id: 87, value: "03" },
    { id: 91, value: "80" },
    { id: 89, value: "14" },
    { id: 101, value: "28" },
    { id: 90, value: "22" },
    { id: 71, value: "18" },
  ],
  [
    { id: 92, value: "24" },
    { id: 93, value: "35" },
    { id: 94, value: "18" },
    { id: 95, value: "67" },
    { id: 105, value: "03" },
    { id: 96, value: "97" },
    { id: 98, value: "63" },
  ],
  [
    { id: 99, value: "99" },
    { id: 100, value: "48" },
    { id: 88, value: "90" },
    { id: 102, value: "98" },
    { id: 103, value: "83" },
    { id: 104, value: "67" },
    { id: 97, value: "81" },
  ],
  [
    { id: 118, value: "06" },
    { id: 109, value: "33" },
    { id: 112, value: "14" },
    { id: 125, value: "21" },
    { id: 116, value: "52" },
    { id: 119, value: "62" },
    { id: 108, value: "53" },
  ],
  [
    { id: 113, value: "12" },
    { id: 114, value: "44" },
    { id: 115, value: "02" },
    { id: 111, value: "91" },
    { id: 117, value: "57" },
    { id: 106, value: "57" },
    { id: 110, value: "24" },
  ],
  [
    { id: 132, value: "11" },
    { id: 121, value: "94" },
    { id: 131, value: "16" },
    { id: 124, value: "77" },
    { id: 107, value: "41" },
    { id: 123, value: "21" },
    { id: 126, value: "94" },
  ],
  [
    { id: 133, value: "97" },
    { id: 128, value: "11" },
    { id: 140, value: "10" },
    { id: 129, value: "19" },
    { id: 122, value: "08" },
    { id: 130, value: "75" },
    { id: 138, value: "90" },
  ],
  [
    { id: 146, value: "18" },
    { id: 135, value: "16" },
    { id: 152, value: "24" },
    { id: 120, value: "72" },
    { id: 139, value: "31" },
    { id: 127, value: "01" },
    { id: 147, value: "60" },
  ],
  [
    { id: 154, value: "20" },
    { id: 142, value: "29" },
    { id: 145, value: "98" },
    { id: 137, value: "85" },
    { id: 151, value: "15" },
    { id: 141, value: "99" },
    { id: 134, value: "90" },
  ],
  [
    { id: 166, value: "10" },
    { id: 148, value: "75" },
    { id: 150, value: "41" },
    { id: 143, value: "98" },
    { id: 136, value: "30" },
    { id: 153, value: "06" },
    { id: 144, value: "59" },
  ],
  [
    { id: 155, value: "11" },
    { id: 172, value: "16" },
    { id: 157, value: "60" },
    { id: 159, value: "55" },
    { id: 160, value: "22" },
    { id: 168, value: "69" },
    { id: 161, value: "43" },
  ],
  [
    { id: 162, value: "93" },
    { id: 164, value: "83" },
    { id: 149, value: "01" },
    { id: 167, value: "97" },
    { id: 183, value: "25" },
    { id: 158, value: "66" },
    { id: 180, value: "48" },
  ],
  [
    { id: 169, value: "32" },
    { id: 170, value: "88" },
    { id: 171, value: "96" },
    { id: 156, value: "66" },
    { id: 173, value: "56" },
    { id: 174, value: "80" },
    { id: 175, value: "55" },
  ],
  [
    { id: 176, value: "88" },
    { id: 177, value: "63" },
    { id: 178, value: "36" },
    { id: 179, value: "27" },
    { id: 165, value: "48" },
    { id: 181, value: "18" },
    { id: 182, value: "79" },
  ],
  [
    { id: 163, value: "75" },
    { id: 184, value: "30" },
    { id: 201, value: "34" },
    { id: 202, value: "55" },
    { id: 185, value: "27" },
    { id: 186, value: "33" },
    { id: 187, value: "33" },
  ],
  [
    { id: 190, value: "59" },
    { id: 191, value: "87" },
    { id: 192, value: "46" },
    { id: 193, value: "59" },
    { id: 194, value: "56" },
    { id: 195, value: "71" },
    { id: 196, value: "84" },
  ],
  [
    { id: "01", value: "90" },
    { id: "02", value: "84" },
    { id: "03", value: "33" },
    { id: "04", value: "33" },
    { id: "05", value: "25" },
    { id: "06", value: "25" },
    { id: "07", value: "08" },
  ],
];

// '05'.30
export const Five = [
  [
    { id: 197, value: "55" },
    { id: 198, value: "88" },
    { id: 199, value: "66" },
    { id: 188, value: "67" },
    { id: 189, value: "11" },
    { id: 200, value: "73" },
    { id: 203, value: "98" },
  ],
  [
    { id: 26, value: "64" },
    { id: 13, value: "55" },
    { id: 25, value: "55" },
    { id: 12, value: "58" },
    { id: "08", value: "79" },
    { id: "09", value: "96" },
    { id: 14, value: "14" },
  ],
  [
    { id: 20, value: "60" },
    { id: 30, value: "89" },
    { id: 31, value: "94" },
    { id: 35, value: "67" },
    { id: 15, value: "34" },
    { id: 16, value: "09" },
    { id: 21, value: "47" },
  ],
  [
    { id: 23, value: "03" },
    { id: 29, value: "34" },
    { id: 10, value: "78" },
    { id: 11, value: "74" },
    { id: 22, value: "12" },
    { id: 27, value: "39" },
    { id: 28, value: "31" },
  ],
  [
    { id: 24, value: "99" },
    { id: 17, value: "81" },
    { id: 18, value: "91" },
    { id: 19, value: "01" },
    { id: 32, value: "79" },
    { id: 33, value: "14" },
    { id: 34, value: "30" },
  ],
  [
    { id: 41, value: "51" },
    { id: 47, value: "52" },
    { id: 45, value: "83" },
    { id: 40, value: "83" },
    { id: 46, value: "06" },
    { id: 36, value: "69" },
    { id: 42, value: "81" },
  ],
  [
    { id: 43, value: "21" },
    { id: 44, value: "87" },
    { id: 51, value: "55" },
    { id: 52, value: "30" },
    { id: 53, value: "62" },
    { id: 37, value: "38" },
    { id: 49, value: "26" },
  ],
  [
    { id: 50, value: "55" },
    { id: 38, value: "62" },
    { id: 56, value: "27" },
    { id: 61, value: "88" },
    { id: 62, value: "92" },
    { id: 39, value: "60" },
    { id: 48, value: "33" },
  ],
  [
    { id: 57, value: "98" },
    { id: 58, value: "45" },
    { id: 59, value: "47" },
    { id: 60, value: "96" },
    { id: 54, value: "65" },
    { id: 55, value: "65" },
    { id: 63, value: "27" },
  ],
  [
    { id: 68, value: "36" },
    { id: 69, value: "11" },
    { id: 73, value: "85" },
    { id: 74, value: "44" },
    { id: 64, value: "71" },
    { id: 65, value: "11" },
    { id: 66, value: "90" },
  ],
  [
    { id: 70, value: "47" },
    { id: 67, value: "25" },
    { id: 75, value: "99" },
    { id: 80, value: "82" },
    { id: 81, value: "07" },
    { id: 76, value: "73" },
    { id: 77, value: "23" },
  ],
  [
    { id: 96, value: "98" },
    { id: 92, value: "97" },
    { id: 93, value: "87" },
    { id: 98, value: "09" },
    { id: 94, value: "22" },
    { id: 83, value: "99" },
    { id: 84, value: "59" },
  ],
  [
    { id: 102, value: "39" },
    { id: 88, value: "64" },
    { id: 89, value: "14" },
    { id: 90, value: "36" },
    { id: 101, value: "61" },
    { id: 85, value: "51" },
    { id: 91, value: "44" },
  ],
  [
    { id: 82, value: "53" },
    { id: 95, value: "54" },
    { id: 97, value: "17" },
    { id: 106, value: "79" },
    { id: 107, value: "37" },
    { id: 108, value: "86" },
    { id: 109, value: "52" },
  ],
  [
    { id: 99, value: "92" },
    { id: 100, value: "78" },
    { id: 86, value: "18" },
    { id: 87, value: "17" },
    { id: 103, value: "05" },
    { id: 104, value: "80" },
    { id: 105, value: "32" },
  ],
  [
    { id: 110, value: "62" },
    { id: 78, value: "70" },
    { id: 79, value: "58" },
    { id: 71, value: "73" },
    { id: 72, value: "11" },
    { id: 111, value: "79" },
    { id: 112, value: "60" },
  ],
  [
    { id: 114, value: "10" },
    { id: 128, value: "18" },
    { id: 113, value: "94" },
    { id: 129, value: "87" },
    { id: 130, value: "97" },
    { id: 118, value: "46" },
    { id: 119, value: "41" },
  ],
  [
    { id: 125, value: "02" },
    { id: 142, value: "14" },
    { id: 127, value: "90" },
    { id: 143, value: "21" },
    { id: 144, value: "15" },
    { id: 120, value: "88" },
    { id: 126, value: "26" },
  ],
  [
    { id: 124, value: "64" },
    { id: 115, value: "26" },
    { id: 116, value: "68" },
    { id: 117, value: "13" },
    { id: 131, value: "46" },
    { id: 132, value: "23" },
    { id: 133, value: "20" },
  ],
  [
    { id: 134, value: "66" },
    { id: 135, value: "81" },
    { id: 136, value: "13" },
    { id: 137, value: "53" },
    { id: 138, value: "48" },
    { id: 139, value: "96" },
    { id: 140, value: "08" },
  ],
  [
    { id: 141, value: "68" },
    { id: 121, value: "85" },
    { id: 122, value: "10" },
    { id: 123, value: "42" },
    { id: 145, value: "24" },
    { id: 146, value: "13" },
    { id: 147, value: "87" },
  ],
  [
    { id: 151, value: "81" },
    { id: 152, value: "84" },
    { id: 157, value: "14" },
    { id: 158, value: "86" },
    { id: 160, value: "99" },
    { id: 163, value: "86" },
    { id: 153, value: "28" },
  ],
  [
    { id: 155, value: "91" },
    { id: 156, value: "03" },
    { id: 148, value: "76" },
    { id: 149, value: "51" },
    { id: 159, value: "49" },
    { id: 154, value: "28" },
    { id: 161, value: "70" },
  ],
  [
    { id: 150, value: "92" },
    { id: 178, value: "28" },
    { id: 166, value: "09" },
    { id: 172, value: "58" },
    { id: 162, value: "14" },
    { id: 179, value: "99" },
    { id: 168, value: "10" },
  ],
  [
    { id: 169, value: "95" },
    { id: 170, value: "56" },
    { id: 171, value: "78" },
    { id: 177, value: "27" },
    { id: 173, value: "65" },
    { id: 174, value: "94" },
    { id: 175, value: "96" },
  ],
  [
    { id: 176, value: "80" },
    { id: 164, value: "78" },
    { id: 165, value: "30" },
    { id: 167, value: "45" },
    { id: 180, value: "36" },
    { id: 181, value: "27" },
    { id: 182, value: "51" },
  ],
  [
    { id: 199, value: "68" },
    { id: 183, value: "77" },
    { id: 184, value: "21" },
    { id: 187, value: "88" },
    { id: 188, value: "58" },
    { id: 200, value: "55" },
    { id: 194, value: "15" },
  ],
  [
    { id: 190, value: "67" },
    { id: 191, value: "91" },
    { id: 192, value: "14" },
    { id: 193, value: "83" },
    { id: 203, value: "88" },
    { id: 195, value: "77" },
    { id: 196, value: "67" },
  ],
  [
    { id: 197, value: "29" },
    { id: 202, value: "74" },
    { id: 198, value: "51" },
    { id: 185, value: "32" },
    { id: 186, value: "48" },
    { id: 201, value: "11" },
    { id: 189, value: "38" },
  ],
];

// '06'.30

export const Six = [
  [
    { id: 17, value: "33" },
    { id: 18, value: "15" },
    { id: "01", value: "96" },
    { id: "05", value: "13" },
    { id: 13, value: "05" },
    { id: 11, value: "45" },
    { id: "06", value: "21" },
  ],
  [
    { id: 25, value: "08" },
    { id: 26, value: "30" },
    { id: 10, value: "32" },
    { id: 20, value: "46" },
    { id: "07", value: "25" },
    { id: 12, value: "22" },
    { id: 14, value: "96" },
  ],

  [
    { id: "03", value: "60" },
    { id: 16, value: "33" },
    { id: "02", value: "80" },
    { id: "04", value: "30" },
    { id: 19, value: "64" },
    { id: 15, value: "45" },
    { id: "09", value: "25" },
  ],
  [
    { id: 39, value: "81" },
    { id: 22, value: "56" },
    { id: 23, value: "68" },
    { id: 27, value: "45" },
    { id: "08", value: "88" },
    { id: 21, value: "21" },
    { id: 28, value: "65" },
  ],
  [
    { id: 29, value: "26" },
    { id: 30, value: "27" },
    { id: 46, value: "10" },
    { id: 31, value: "71" },
    { id: 34, value: "79" },
    { id: 47, value: "28" },
    { id: 35, value: "64" },
  ],
  [
    { id: 24, value: "07" },
    { id: 40, value: "41" },
    { id: 53, value: "11" },
    { id: 41, value: "46" },
    { id: 52, value: "11" },
    { id: 42, value: "21" },
    { id: 51, value: "09" },
  ],
  [
    { id: 59, value: "36" },
    { id: 49, value: "14" },
    { id: 32, value: "16" },
    { id: 33, value: "89" },
    { id: 60, value: "06" },
    { id: 48, value: "67" },
    { id: 61, value: "87" },
  ],
  [
    { id: 50, value: "10" },
    { id: 36, value: "20" },
    { id: 56, value: "49" },
    { id: 37, value: "91" },
    { id: 54, value: "13" },
    { id: 55, value: "29" },
    { id: 38, value: "89" },
  ],
  [
    { id: 45, value: "94" },
    { id: 57, value: "50" },
    { id: 62, value: "95" },
    { id: 43, value: "11" },
    { id: 58, value: "25" },
    { id: 63, value: "16" },
    { id: 44, value: "41" },
  ],
  [
    { id: 70, value: "02" },
    { id: 81, value: "53" },
    { id: 69, value: "76" },
    { id: 82, value: "80" },
    { id: 64, value: "26" },
    { id: 65, value: "94" },
    { id: 80, value: "20" },
  ],
  [
    { id: 71, value: "26" },
    { id: 72, value: "20" },
    { id: 73, value: "81" },
    { id: 68, value: "54" },
    { id: 75, value: "27" },
    { id: 76, value: "83" },
    { id: 77, value: "78" },
  ],
  [
    { id: 66, value: "95" },
    { id: 79, value: "44" },
    { id: 84, value: "31" },
    { id: 74, value: "19" },
    { id: 67, value: "02" },
    { id: 83, value: "09" },
    { id: 78, value: "21" },
  ],
  [
    { id: 90, value: "07" },
    { id: 95, value: "01" },
    { id: 96, value: "56" },
    { id: 85, value: "31" },
    { id: 86, value: "93" },
    { id: 91, value: "39" },
    { id: 89, value: "80" },
  ],
  [
    { id: 92, value: "73" },
    { id: 93, value: "02" },
    { id: 94, value: "85" },
    { id: 87, value: "79" },
    { id: 88, value: "69" },
    { id: 97, value: "40" },
    { id: 98, value: "31" },
  ],
  [
    { id: 110, value: "34" },
    { id: 103, value: "37" },
    { id: 109, value: "72" },
    { id: 104, value: "77" },
    { id: 111, value: "17" },
    { id: 99, value: "95" },
    { id: 105, value: "04" },
  ],
  [
    { id: 107, value: "98" },
    { id: 112, value: "94" },
    { id: 123, value: "13" },
    { id: 101, value: "74" },
    { id: 122, value: "70" },
    { id: 102, value: "53" },
    { id: 121, value: "21" },
  ],
  [
    { id: 100, value: "47" },
    { id: 118, value: "79" },
    { id: 136, value: "48" },
    { id: 137, value: "58" },
    { id: 138, value: "56" },
    { id: 113, value: "34" },
    { id: 119, value: "12" },
  ],
  [
    { id: 120, value: "27" },
    { id: 139, value: "61" },
    { id: 124, value: "80" },
    { id: 106, value: "43" },
    { id: 108, value: "88" },
    { id: 125, value: "76" },
    { id: 126, value: "67" },
  ],
  [
    { id: 143, value: "60" },
    { id: 127, value: "72" },
    { id: 147, value: "68" },
    { id: 145, value: "40" },
    { id: 128, value: "92" },
    { id: 146, value: "88" },
    { id: 132, value: "96" },
  ],
  [
    { id: 134, value: "50" },
    { id: 135, value: "71" },
    { id: 114, value: "32" },
    { id: 131, value: "82" },
    { id: 117, value: "36" },
    { id: 140, value: "50" },
    { id: 142, value: "85" },
  ],
  [
    { id: 157, value: "58" },
    { id: 130, value: "25" },
    { id: 116, value: "26" },
    { id: 155, value: "05" },
    { id: 133, value: "36" },
    { id: 151, value: "17" },
    { id: 154, value: "92" },
  ],
  [
    { id: 148, value: "51" },
    { id: 149, value: "25" },
    { id: 150, value: "88" },
    { id: 152, value: "49" },
    { id: 153, value: "19" },
    { id: 156, value: "59" },
    { id: 161, value: "72" },
  ],
  [
    { id: 158, value: "12" },
    { id: 141, value: "43" },
    { id: 115, value: "20" },
    { id: 144, value: "58" },
    { id: 129, value: "54" },
    { id: 159, value: "58" },
    { id: 160, value: "50" },
  ],
  [
    { id: 167, value: "65" },
    { id: 176, value: "30" },
    { id: 179, value: "12" },
    { id: 180, value: "50" },
    { id: 172, value: "01" },
    { id: 182, value: "67" },
    { id: 168, value: "19" },
  ],
  [
    { id: 169, value: "84" },
    { id: 174, value: "96" },
    { id: 170, value: "48" },
    { id: 181, value: "31" },
    { id: 171, value: "93" },
    { id: 173, value: "27" },
    { id: 175, value: "81" },
  ],
  [
    { id: 166, value: "70" },
    { id: 178, value: "72" },
    { id: 162, value: "42" },
    { id: 177, value: "42" },
    { id: 188, value: "68" },

    { id: 165, value: "37" },
    { id: 163, value: "98" },
  ],
  [
    { id: 183, value: "67" },
    { id: 184, value: "89" },
    { id: 185, value: "48" },
    { id: 186, value: "60" },
    { id: 187, value: "65" },
    { id: 164, value: "32" },
    { id: 189, value: "87" },
  ],
  [
    { id: 190, value: "49" },
    { id: 240, value: "72" },
    { id: 200, value: "91" },
    { id: 192, value: "87" },
    { id: 201, value: "62" },
    { id: 195, value: "64" },
    { id: 191, value: "19" },
  ],
  [
    { id: 205, value: "99" },
    { id: 199, value: "87" },
    { id: 210, value: "13" },
    { id: 211, value: "12" },
    { id: 216, value: "43" },

    { id: 204, value: "61" },
    { id: 206, value: "55" },
  ],
  [
    { id: 203, value: "84" },
    { id: 207, value: "37" },
    { id: 196, value: "65" },
    { id: 213, value: "99" },
    { id: 214, value: "53" },
    { id: 208, value: "32" },
    { id: 209, value: "24" },
  ],
  [
    { id: 197, value: "64" },
    { id: 212, value: "20" },
    { id: 198, value: "56" },
    { id: 215, value: "12" },
    { id: 202, value: "82" },
    { id: 193, value: "99" },
    { id: 194, value: "78" },
  ],
];

// '07'.30

export const Seven = [
  [
    { id: 70, value: "13" },
    { id: 67, value: "10" },
    { id: 65, value: "30" },
    { id: 66, value: "38" },
    { id: 69, value: "15" },
    { id: 68, value: "23" },
    { id: 64, value: "66" },
  ],
  [
    { id: 24, value: "90" },
    { id: 14, value: "08" },
    { id: 11, value: "92" },
    { id: 12, value: "14" },
    { id: 10, value: "46" },
    { id: 25, value: "60" },
    { id: 13, value: "02" },
  ],
  [
    { id: 84, value: "73" },
    { id: 83, value: "57" },
    { id: 79, value: "91" },
    { id: 80, value: "08" },
    { id: 81, value: "75" },
    { id: 82, value: "97" },
    { id: 78, value: "31" },
  ],
  [
    { id: 22, value: "99" },
    { id: 23, value: "64" },
    { id: "08", value: "75" },
    { id: "09", value: "30" },
    { id: 26, value: "52" },
    { id: 27, value: "58" },
    { id: 28, value: "52" },
  ],

  [
    { id: 37, value: "50" },
    { id: 42, value: "72" },
    { id: 38, value: "50" },
    { id: 36, value: "99" },
    { id: 39, value: "45" },
    { id: 40, value: "45" },
    { id: 41, value: "36" },
  ],
  [
    { id: 55, value: "08" },
    { id: 45, value: "10" },
    { id: 49, value: "57" },
    { id: 46, value: "10" },
    { id: 47, value: "94" },
    { id: 48, value: "07" },
    { id: 53, value: "41" },
  ],
  [
    { id: 50, value: "18" },
    { id: 51, value: "41" },
    { id: 52, value: "42" },
    { id: 43, value: "49" },
    { id: 44, value: "07" },
    { id: 54, value: "42" },
    { id: 56, value: "30" },
  ],
  [
    { id: "01", value: "28" },
    { id: "02", value: "44" },
    { id: 92, value: "02" },
    { id: 97, value: "45" },
    { id: "04", value: "26" },
    { id: "05", value: "46" },
    { id: 98, value: "27" },
  ],
  [
    { id: 57, value: "68" },
    { id: 58, value: "96" },
    { id: 59, value: "14" },
    { id: 60, value: "31" },
    { id: 61, value: "43" },
    { id: 62, value: "36" },
    { id: 63, value: "77" },
  ],
  [
    { id: "03", value: "12" },
    { id: 93, value: "81" },
    { id: 94, value: "94" },
    { id: "06", value: "22" },
    { id: 95, value: "39" },
    { id: 96, value: "15" },
    { id: "07", value: "35" },
  ],

  [
    { id: 15, value: "14" },
    { id: 16, value: "20" },
    { id: 17, value: "51" },
    { id: 18, value: "65" },
    { id: 19, value: "10" },
    { id: 20, value: "34" },
    { id: 21, value: "56" },
  ],
  [
    { id: 85, value: "22" },
    { id: 86, value: "55" },
    { id: 87, value: "53" },
    { id: 88, value: "25" },
    { id: 89, value: "20" },
    { id: 90, value: "61" },
    { id: 91, value: "12" },
  ],

  [
    { id: 35, value: "30" },
    { id: 30, value: "17" },
    { id: 31, value: "90" },
    { id: 32, value: "88" },
    { id: 29, value: "20" },
    { id: 33, value: "49" },
    { id: 34, value: "14" },
  ],
  [
    { id: 159, value: "73" },
    { id: 160, value: "05" },
    { id: 157, value: "59" },
    { id: 158, value: "71" },
    { id: 156, value: "07" },
    { id: 155, value: "49" },
    { id: 161, value: "98" },
  ],
  [
    { id: 105, value: "89" },
    { id: 101, value: "89" },
    { id: 100, value: "21" },
    { id: 103, value: "18" },
    { id: 99, value: "24" },
    { id: 104, value: "91" },
    { id: 102, value: "43" },
  ],
  [
    { id: 110, value: "46" },
    { id: 112, value: "40" },
    { id: 108, value: "29" },
    { id: 109, value: "79" },
    { id: 107, value: "39" },
    { id: 111, value: "64" },
    { id: 106, value: "46" },
  ],
  [
    { id: 122, value: "09" },
    { id: 119, value: "91" },
    { id: 121, value: "32" },
    { id: 115, value: "29" },
    { id: 116, value: "96" },
    { id: 118, value: "25" },
    { id: 114, value: "52" },
  ],
  [
    { id: 120, value: "96" },
    { id: 123, value: "34" },
    { id: 117, value: "85" },
    { id: 124, value: "89" },
    { id: 126, value: "81" },
    { id: 113, value: "74" },
    { id: 125, value: "84" },
  ],

  [
    { id: 145, value: "62" },
    { id: 139, value: "55" },
    { id: 134, value: "19" },
    { id: 135, value: "72" },
    { id: 136, value: "03" },
    { id: 140, value: "57" },
    { id: 138, value: "73" },
  ],
  [
    { id: 147, value: "54" },
    { id: 144, value: "08" },
    { id: 142, value: "62" },
    { id: 143, value: "27" },
    { id: 137, value: "71" },
    { id: 141, value: "20" },
    { id: 146, value: "73" },
  ],

  [
    { id: 77, value: "59" },
    { id: 72, value: "52" },
    { id: 73, value: "67" },
    { id: 74, value: "78" },
    { id: 71, value: "48" },
    { id: 75, value: "25" },
    { id: 164, value: "30" },
  ],
  [
    { id: 162, value: "58" },
    { id: 163, value: "96" },
    { id: 76, value: "62" },
    { id: 165, value: "13" },
    { id: 166, value: "76" },
    { id: 167, value: "51" },
    { id: 168, value: "01" },
  ],
  [
    { id: 188, value: "56" },
    { id: 186, value: "93" },
    { id: 183, value: "94" },
    { id: 184, value: "75" },
    { id: 187, value: "60" },
    { id: 189, value: "97" },
    { id: 185, value: "85" },
  ],
  [
    { id: 129, value: "93" },
    { id: 174, value: "37" },
    { id: 130, value: "20" },
    { id: 171, value: "47" },
    { id: 178, value: "89" },
    { id: 172, value: "56" },
    { id: 175, value: "11" },
  ],
  [
    { id: 127, value: "56" },
    { id: 128, value: "68" },
    { id: 169, value: "52" },
    { id: 170, value: "48" },
    { id: 131, value: "62" },
    { id: 132, value: "13" },
    { id: 133, value: "82" },
  ],
  [
    { id: 176, value: "38" },
    { id: 177, value: "72" },
    { id: 173, value: "91" },
    { id: 179, value: "76" },
    { id: 180, value: "10" },
    { id: 181, value: "31" },
    { id: 182, value: "23" },
  ],
  [
    { id: 148, value: "07" },
    { id: 149, value: "11" },
    { id: 150, value: "56" },
    { id: 151, value: "48" },
    { id: 152, value: "34" },
    { id: 153, value: "16" },
    { id: 154, value: "99" },
  ],
  [
    { id: 190, value: "42" },
    { id: 191, value: "88" },
    { id: 192, value: "68" },
    { id: 193, value: "47" },
    { id: 194, value: "77" },
    { id: 195, value: "70" },
    { id: 196, value: "54" },
  ],
  [
    { id: 13, value: "18" },
    { id: "09", value: "79" },
    { id: 10, value: "30" },
    { id: 14, value: "12" },
    { id: 11, value: "17" },
    { id: "08", value: "46" },
    { id: 12, value: "89" },
  ],
];

// '08'.30

export const Eight = [
  [
    { id: 197, value: "16" },
    { id: 198, value: "11" },
    { id: 199, value: "29" },
    { id: 200, value: "91" },
    { id: 201, value: "88" },
    { id: 202, value: "98" },
    { id: 203, value: "54" },
  ],
  [
    { id: 25, value: "34" },
    { id: 26, value: "40" },
    { id: 27, value: "16" },
    { id: 17, value: "95" },
    { id: 18, value: "46" },
    { id: 19, value: "79" },
    { id: 20, value: "20" },
  ],

  [
    { id: 15, value: "46" },
    { id: 22, value: "50" },
    { id: 28, value: "72" },
    { id: 16, value: "29" },
    { id: 23, value: "28" },
    { id: 24, value: "16" },
    { id: 36, value: "82" },
  ],
  [
    { id: 35, value: "33" },
    { id: 30, value: "14" },
    { id: 29, value: "36" },
    { id: 31, value: "06" },
    { id: 39, value: "26" },
    { id: 40, value: "36" },
    { id: 41, value: "26" },
  ],
  [
    { id: 37, value: "38" },
    { id: 38, value: "01" },
    { id: 32, value: "45" },
    { id: 33, value: "01" },
    { id: 34, value: "77" },
    { id: 42, value: "10" },
    { id: 55, value: "56" },
  ],
  [
    { id: 63, value: "96" },
    { id: 61, value: "36" },
    { id: 46, value: "26" },
    { id: 62, value: "54" },
    { id: 43, value: "35" },
    { id: 44, value: "14" },
    { id: 45, value: "19" },
  ],
  [
    { id: 51, value: "14" },
    { id: 65, value: "86" },
    { id: 53, value: "64" },
    { id: 50, value: "13" },
    { id: 64, value: "86" },
    { id: 66, value: "69" },
    { id: "03", value: "48" },
  ],
  [
    { id: 57, value: "94" },
    { id: 58, value: "26" },
    { id: 59, value: "13" },
    { id: 60, value: "28" },
    { id: 47, value: "36" },
    { id: 48, value: "20" },
    { id: 49, value: "55" },
  ],
  [
    { id: 69, value: "65" },
    { id: "07", value: "48" },
    { id: "04", value: "32" },
    { id: "05", value: "17" },
    { id: "03", value: "48" },
    { id: "06", value: "17" },
    { id: "02", value: "36" },
  ],
  [
    { id: 68, value: "34" },
    { id: "01", value: "90" },
    { id: 56, value: "03" },
    { id: 67, value: "01" },
    { id: 52, value: "47" },
    { id: 54, value: "60" },
    { id: 70, value: "85" },
  ],
  [
    { id: 73, value: "04" },
    { id: 85, value: "50" },
    { id: 86, value: "75" },

    { id: 72, value: "62" },
    { id: 75, value: "15" },
    { id: 76, value: "56" },
    { id: 108, value: "73" },
  ],
  [
    { id: 106, value: "86" },
    { id: 107, value: "35" },
    { id: 77, value: "03" },
    { id: 80, value: "92" },
    { id: 108, value: "73" },
    { id: 109, value: "44" },
    { id: 79, value: "31" },
  ],
  [
    { id: 74, value: "62" },
    { id: 91, value: "45" },
    { id: 87, value: "25" },
    { id: 71, value: "11" },
    { id: 89, value: "24" },
    { id: 90, value: "03" },
    { id: 88, value: "45" },
  ],
  [
    { id: 97, value: "72" },
    { id: 93, value: "63" },
    { id: 94, value: "10" },
    { id: 95, value: "74" },
    { id: 102, value: "04" },
    { id: 96, value: "92" },
    { id: 103, value: "72" },
  ],
  [
    { id: 92, value: "37" },
    { id: 105, value: "07" },
    { id: 100, value: "60" },
    { id: 99, value: "16" },
    { id: 101, value: "56" },
    { id: 104, value: "92" },
    { id: 98, value: "30" },
  ],
  [
    { id: 78, value: "79" },
    { id: 82, value: "68" },
    { id: 122, value: "60" },
    { id: 123, value: "38" },
    { id: 84, value: "44" },
    { id: 110, value: "54" },
    { id: 83, value: "84" },
  ],
  [
    { id: 113, value: "50" },
    { id: 114, value: "96" },
    { id: 115, value: "23" },
    { id: 116, value: "38" },
    { id: 117, value: "30" },
    { id: 118, value: "83" },
    { id: 119, value: "86" },
  ],
  [
    { id: 158, value: "97" },
    { id: 128, value: "92" },
    { id: 124, value: "53" },
    { id: 112, value: "74" },
    { id: 125, value: "82" },
    { id: 126, value: "01" },
    { id: 111, value: "07" },
  ],
  [
    { id: 137, value: "28" },
    { id: 157, value: "25" },
    { id: 127, value: "52" },
    { id: 156, value: "87" },
    { id: 120, value: "31" },
    { id: 121, value: "65" },
    { id: 155, value: "36" },
  ],
  [
    { id: 135, value: "75" },
    { id: 138, value: "63" },
    { id: 160, value: "83" },
    { id: 139, value: "80" },
    { id: 141, value: "83" },
    { id: 136, value: "73" },
    { id: 140, value: "05" },
  ],
  [
    { id: 151, value: "95" },
    { id: 145, value: "83" },
    { id: 134, value: "13" },
    { id: 146, value: "94" },
    { id: 150, value: "83" },
    { id: 153, value: "10" },
    { id: 147, value: "37" },
  ],
  [
    { id: 148, value: "46" },
    { id: 149, value: "07" },
    { id: 142, value: "96" },
    { id: 143, value: "20" },
    { id: 144, value: "69" },
    { id: 154, value: "48" },
    { id: 161, value: "08" },
  ],
  [
    { id: 129, value: "69" },
    { id: 130, value: "05" },
    { id: 131, value: "90" },
    { id: 132, value: "57" },
    { id: 152, value: "74" },
    { id: 133, value: "33" },
    { id: 159, value: "52" },
  ],
  [
    { id: 164, value: "12" },
    { id: 173, value: "24" },

    { id: 172, value: "52" },
    { id: 174, value: "79" },
    { id: 162, value: "62" },
    { id: 163, value: "82" },
    { id: 165, value: "23" },
  ],
  [
    { id: 169, value: "59" },
    { id: 185, value: "58" },
    { id: 170, value: "21" },
    { id: 183, value: "71" },

    { id: 186, value: "41" },
    { id: 171, value: "17" },
    { id: 175, value: "21" },
  ],
  [
    { id: 176, value: "52" },
    { id: 177, value: "63" },
    { id: 178, value: "75" },
    { id: 179, value: "98" },
    { id: 180, value: "56" },
    { id: 181, value: "26" },
    { id: 182, value: "75" },
  ],
  [
    { id: 166, value: "97" },
    { id: 167, value: "25" },
    { id: 168, value: "39" },
    { id: 132, value: "57" },
    { id: 187, value: "22" },
    { id: 188, value: "54" },
    { id: 189, value: "42" },
  ],
  [
    { id: 204, value: "32" },
    { id: 205, value: "14" },
    { id: 190, value: "54" },
    { id: 202, value: "29" },
    { id: 209, value: "47" },
    { id: 191, value: "83" },
    { id: 192, value: "94" },
  ],
  [
    { id: 197, value: "36" },
    { id: 208, value: "27" },
    { id: 198, value: "70" },
    { id: 199, value: "55" },
    { id: 210, value: "51" },
    { id: 200, value: "17" },
    { id: 201, value: "47" },
  ],
  [
    { id: 193, value: "76" },
    { id: 194, value: "52" },
    { id: 199, value: "55" },
    { id: 195, value: "74" },
    { id: 196, value: "24" },
    { id: 206, value: "12" },
    { id: 207, value: "23" },
  ],
];

// '09'.30
export const Nine = [
  [
    { id: "01", value: "37" },
    { id: "02", value: "54" },
    { id: "03", value: "13" },
    { id: "04", value: "26" },
    { id: "05", value: "44" },
    { id: "06", value: "29" },
    { id: "07", value: "39" },
  ],
  [
    { id: "08", value: "20" },
    { id: "09", value: "16" },
    { id: 10, value: "86" },
    { id: 11, value: "48" },
    { id: 12, value: "46" },
    { id: 13, value: "22" },
    { id: 14, value: "17" },
  ],
  [
    { id: 15, value: "51" },
    { id: 16, value: "80" },
    { id: 17, value: "17" },
    { id: 18, value: "76" },
    { id: 19, value: "97" },
    { id: 20, value: "50" },
    { id: 21, value: "85" },
  ],
  [
    { id: 22, value: "65" },
    { id: 23, value: "33" },
    { id: 24, value: "44" },
    { id: 25, value: "31" },
    { id: 26, value: "65" },
    { id: 27, value: "60" },
    { id: 28, value: "45" },
  ],
  [
    { id: 29, value: "76" },
    { id: 30, value: "71" },
    { id: 31, value: "65" },
    { id: 32, value: "73" },
    { id: 33, value: "55" },
    { id: 34, value: "01" },
    { id: 35, value: "21" },
  ],
  [
    { id: 36, value: "26" },
    { id: 37, value: "57" },
    { id: 38, value: "99" },
    { id: 39, value: "36" },
    { id: 40, value: "64" },
    { id: 41, value: "45" },
    { id: 42, value: "14" },
  ],
  [
    { id: 43, value: "42" },
    { id: 44, value: "99" },
    { id: 45, value: "08" },
    { id: 46, value: "82" },
    { id: 47, value: "26" },
    { id: 48, value: "92" },
    { id: 49, value: "39" },
  ],
  [
    { id: 50, value: "72" },
    { id: 51, value: "98" },
    { id: 52, value: "02" },
    { id: 53, value: "36" },
    { id: 54, value: "86" },
    { id: 55, value: "92" },
    { id: 56, value: "43" },
  ],
  [
    { id: 57, value: "30" },
    { id: 58, value: "64" },
    { id: 59, value: "24" },
    { id: 60, value: "79" },
    { id: 61, value: "55" },
    { id: 62, value: "96" },
    { id: 63, value: "94" },
  ],
  [
    { id: 64, value: "27" },
    { id: 65, value: "93" },
    { id: 66, value: "45" },
    { id: 67, value: "81" },
    { id: 68, value: "62" },
    { id: 69, value: "19" },
    { id: 70, value: "22" },
  ],
  [
    { id: 71, value: "87" },
    { id: 72, value: "45" },
    { id: 73, value: "36" },
    { id: 74, value: "85" },
    { id: 75, value: "07" },
    { id: 76, value: "04" },
    { id: 77, value: "24" },
  ],
  [
    { id: 78, value: "69" },
    { id: 79, value: "86" },
    { id: 80, value: "44" },
    { id: 81, value: "65" },
    { id: 82, value: "74" },
    { id: 83, value: "14" },
    { id: 84, value: "14" },
  ],
  [
    { id: 85, value: "86" },
    { id: 86, value: "97" },
    { id: 87, value: "44" },
    { id: 88, value: "09" },
    { id: 89, value: "48" },
    { id: 90, value: "48" },
    { id: 91, value: "93" },
  ],
  [
    { id: 92, value: "38" },
    { id: 93, value: "24" },
    { id: 94, value: "49" },
    { id: 95, value: "51" },
    { id: 96, value: "80" },
    { id: 97, value: "79" },
    { id: 98, value: "52" },
  ],
  [
    { id: 99, value: "58" },
    { id: 100, value: "95" },
    { id: 101, value: "04" },
    { id: 102, value: "65" },
    { id: 103, value: "23" },
    { id: 104, value: "64" },
    { id: 105, value: "28" },
  ],
  [
    { id: 106, value: "41" },
    { id: 107, value: "60" },
    { id: 108, value: "12" },
    { id: 109, value: "03" },
    { id: 110, value: "51" },
    { id: 111, value: "90" },
    { id: 112, value: "03" },
  ],
  [
    { id: 113, value: "40" },
    { id: 114, value: "49" },
    { id: 115, value: "76" },
    { id: 116, value: "95" },
    { id: 117, value: "35" },
    { id: 118, value: "38" },
    { id: 119, value: "93" },
  ],
  [
    { id: 120, value: "26" },
    { id: 121, value: "26" },
    { id: 122, value: "80" },
    { id: 123, value: "12" },
    { id: 124, value: "22" },
    { id: 125, value: "97" },
    { id: 126, value: "06" },
  ],
  [
    { id: 127, value: "62" },
    { id: 128, value: "81" },
    { id: 129, value: "98" },
    { id: 130, value: "95" },
    { id: 131, value: "14" },
    { id: 132, value: "44" },
    { id: 133, value: "17" },
  ],
  [
    { id: 134, value: "87" },
    { id: 135, value: "14" },
    { id: 136, value: "37" },
    { id: 137, value: "24" },
    { id: 138, value: "86" },
    { id: 139, value: "61" },
    { id: 140, value: "40" },
  ],
  [
    { id: 141, value: "71" },
    { id: 142, value: "82" },
    { id: 143, value: "73" },
    { id: 144, value: "02" },
    { id: 145, value: "36" },
    { id: 146, value: "11" },
    { id: 147, value: "49" },
  ],
  [
    { id: 148, value: "67" },
    { id: 149, value: "89" },
    { id: 150, value: "36" },
    { id: 151, value: "66" },
    { id: 152, value: "04" },
    { id: 153, value: "55" },
    { id: 154, value: "34" },
  ],
  [
    { id: 155, value: "96" },
    { id: 156, value: "53" },
    { id: 157, value: "37" },
    { id: 158, value: "29" },
    { id: 159, value: "87" },
    { id: 160, value: "60" },
    { id: 161, value: "21" },
  ],
  [
    { id: 162, value: "42" },
    { id: 163, value: "47" },
    { id: 164, value: "39" },
    { id: 165, value: "89" },
    { id: 166, value: "46" },
    { id: 167, value: "84" },
    { id: 168, value: "24" },
  ],
  [
    { id: 169, value: "55" },
    { id: 170, value: "45" },
    { id: 171, value: "78" },
    { id: 172, value: "73" },
    { id: 173, value: "65" },
    { id: 174, value: "19" },
    { id: 175, value: "80" },
  ],
  [
    { id: 176, value: "93" },
    { id: 177, value: "72" },
    { id: 178, value: "65" },
    { id: 179, value: "53" },
    { id: 180, value: "55" },
    { id: 181, value: "92" },
    { id: 182, value: "67" },
  ],
  [
    { id: 183, value: "36" },
    { id: 184, value: "98" },
    { id: 185, value: "72" },
    { id: 186, value: "64" },
    { id: 187, value: "77" },
    { id: 188, value: "84" },
    { id: 189, value: "66" },
  ],
  [
    { id: 190, value: "92" },
    { id: 191, value: "65" },
    { id: 192, value: "10" },
    { id: 193, value: "56" },
    { id: 194, value: "32" },
    { id: 195, value: "40" },
    { id: 196, value: "14" },
  ],
  [
    { id: 197, value: "12" },
    { id: 198, value: "13" },
    { id: 199, value: "18" },
    { id: 200, value: "56" },
    { id: 201, value: "66" },
    { id: 202, value: "43" },
    { id: 203, value: "62" },
  ],
];




